(function () {
    'use strict';

    a3_cabin_reports.factory('SaFeedbackInfoFactory', SaFeedbackInfoFactory);
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name SaFeedbacksFactory
    * @description 
    * Add, Update and Get SaFeedbacks Info
    * @ngInject
    */
    function SaFeedbackInfoFactory(GenericService, defaultCalendarDate, CrewRouteFactory, FlightFactory, localStorageMD5Service) {

        var objType = 'SaFeedbackInfo';
        var objCallback = SaFeedbackInfo;

        /**
         * Initialize the SaFeedbackInfo
         * @memberof SaFeedbacksFactory
         */
        function SaFeedbackInfo() {
            this.questions = [];
            this.assessments = [];
            this.saMembers = [];
            this.showSaAssessmentModal = false;
            // this.storedFeedbacks = [];
        }

        var service = {
            setSaFeedbacks: setSaFeedbacks,
            getFeedbacksInfo:getFeedbacksInfo,
            getQuestions: getQuestions,
            getSaMembersForFeedback: getSaMembersForFeedback,
            hasSyncedFeedbacks: hasSyncedFeedbacks,
            showSaAssessmentReminderModal: showSaAssessmentReminderModal,
            updateShowSaAssessmentModal: updateShowSaAssessmentModal
        };

        function setSaFeedbacks(feedbacksObj) {
            if (feedbacksObj != null && feedbacksObj.Questions != null && feedbacksObj.Assessments != null) {
                 // Create an empty array to hold all CrewAssessmentMembers
                var crewAssessmentMembers = [];

                // Loop through each assessment and take its CrewAssessmentMembers
                feedbacksObj.Assessments.forEach(function(assessment) {
                    if (assessment.CrewAssessmentMembers && Array.isArray(assessment.CrewAssessmentMembers)) {
                        crewAssessmentMembers = crewAssessmentMembers.concat(assessment.CrewAssessmentMembers);
                    }
                });

                var uniqueMembers = {};
                crewAssessmentMembers.forEach(function(member) {
                    if (member && member.CrewId) {
                        uniqueMembers[member.CrewId] = member;
                    }
                });

                var uniqueMembersArray = Object.keys(uniqueMembers).map(function(key) {
                    return uniqueMembers[key];
                });

                var saFeedbackInfo = { 
                    questions: feedbacksObj.Questions, 
                    assessments: feedbacksObj.Assessments,
                    saMembers: uniqueMembersArray,
                    showSaAssessmentModal:  true
                }; // saMembers: feedbacksObj.SaMembers , storedFeedbacks : feedbacksObj.StoredFeedbacks};
                GenericService.saveOne(saFeedbackInfo, objType, objCallback);
            }
        }

        /**
         * Get Feedbacks Info from local storage
         */
        function getFeedbacksInfo() {
            return GenericService.getOne(objType, objCallback);
        }

        /**
         * Get SA members for the feedbacks
         */
        function getSaMembersForFeedback(saMembersIdsInRoute) {
            var feedbacksInfo = getFeedbacksInfo();
            // Check if feedbacksInfo or saMembersIdsInRoute is not defined/null
            if (!saMembersIdsInRoute || !feedbacksInfo || !feedbacksInfo.saMembers || !Array.isArray(feedbacksInfo.saMembers)) {
                console.error("Invalid feedbacksInfo or saMembersIdsInRoute");
                return [];
            }

            // Get the current date + 1 day
            var nowPlusOne = new Date();
            nowPlusOne.setDate(nowPlusOne.getDate() + 1);

            if(defaultCalendarDate){
                nowPlusOne = new Date(defaultCalendarDate);
            }

            const commonSaMembers = feedbacksInfo.saMembers.filter(member => {
                const memberEndDate = new Date(member.EndPeriod);
        
                // Check if the member's ID matches and the endDate is valid
                return (
                    saMembersIdsInRoute.includes(member.CrewAimsId) &&
                    memberEndDate >= nowPlusOne // End date is greater than or equal to now + 1
                );
            });

            return commonSaMembers;
        }

        function hasSyncedFeedbacks(dutyNo, dutyDay, feedbackDate){
            var isSynced = false;
            var feedbacksInfo = getFeedbacksInfo();
            if(feedbacksInfo && feedbacksInfo.assessments && feedbacksInfo.assessments.length > 0){
                var storedFeedback = feedbacksInfo.assessments.find(f => f.DutyNo == dutyNo && f.DutyDay == dutyDay && 
                   (!f.FeedbackDate || f.FeedbackDate == feedbackDate));
                //add isexist or id not null
                if(storedFeedback && storedFeedback.Id != null){
                    isSynced = true;
                }
            }
            return isSynced;
        }


       /**
         * The question object
         */
        function question() {
			this.Id = null;
			this.Description = null;
			this.Label = null;
			this.OrderNo = null;
			this.ItemValue = 3;
			this.GetId = GetId;
		}

        //Object services
        /**
         * Overide default get Id
         * @memberof CrewAssessmentTemplateFactory
         * @returns {number} Id 
         */
		function GetId(){
			return this.Id;
		}

        /**
         * Get questions for the feedback forms
         */
        function getQuestions(){
            var feedbacksInfo = getFeedbacksInfo();

            // Assuming feedbacksInfo.questions is an array of question data
            return feedbacksInfo.questions.map(qData => {
                var q = new question();
                q.Id = qData.Id;
                q.Description = qData.Description;
                q.Label = qData.Label;
                q.OrderNo = qData.OrderNo;
                q.ItemValue = qData.ItemValue || 3; // Default value if not provided
        
                return q;
            });
        }

        // function showSaAssessmentReminderModal() {
        //     // Get all crew routes from storage
        //     var feedbacksInfo = getFeedbacksInfo();
        //     if(feedbacksInfo && feedbacksInfo.showSaAssessmentModal){
        //         var crewRoutes = CrewRouteFactory.getCrewRoutesFromStorage();
        //         var nowUtc = moment.utc();
        //         if(defaultCalendarDate){
        //             nowUtc = moment(defaultCalendarDate).utc();
        //         }
                
        //         // Return true if at least one route has DutyEnd before nowUtc and Status !== "Stored"
        //         return crewRoutes.some(function(route) {
        //             debugger
        //             return moment(route.DutyEnd).isBefore(nowUtc) && route.Status !== 'Stored';
        //         });
        //     } else {
        //         return false;
        //     }
        // }

        function showSaAssessmentReminderModal() {
            var info = getFeedbacksInfo();
            if (!info || !info.showSaAssessmentModal) return false;

            var nowUtc = defaultCalendarDate ? moment(defaultCalendarDate).utc() : moment.utc();

            var assessments = Array.isArray(info.assessments) ? info.assessments : [];

            return assessments.some(function (a) {
                if (!a || !a.DutyDate) return false;

                var dutyMoment = moment(a.DutyDate).utc();
                if (!dutyMoment.isValid()) return false;

                var isPast = dutyMoment.isBefore(nowUtc);
                var isPending = (a.Id == null); // not yet stored/synced on server

                return isPast && isPending && hasAvailableSaAssessmentForm(a);
            });
        }

        function hasAvailableSaAssessmentForm(assessment) {
            var flights = FlightFactory.getFlightsByRoutePerDay(assessment.Route, assessment.DutyDate, assessment.FeedbackDate);
            if (!flights || flights.length === 0) return false;

            var saMembersInRoute = CrewRouteFactory.getSACrewMembersFromRoute(assessment.DutyNo, assessment.DutyDay, assessment.FeedbackDate);
            var saMembersNeedFeedback = getSaMembersForFeedback(saMembersInRoute);
            if (!saMembersNeedFeedback || saMembersNeedFeedback.length === 0) return false;

            var saAimsIdsNeedFeedback = saMembersNeedFeedback.map(function (member) {
                return member.CrewAimsId;
            });

            var flightIds = flights.map(function (flight) {
                return flight.FlightId;
            });

            var commonFlightsWithSA = localStorageMD5Service.get('CommonFlightsWithSA') || [];
            var saAimsIdsWithCommonFlights = commonFlightsWithSA
                .filter(function (entry) {
                    return entry.Flights && entry.Flights.some(function (flight) {
                        return flightIds.includes(flight.FlightId);
                    });
                })
                .map(function (entry) {
                    return entry.SaAimsId;
                });

            var crewMembers = Array.isArray(assessment.CrewAssessmentMembers) ? assessment.CrewAssessmentMembers : [];

            return crewMembers.some(function (member) {
                var matchesFeedbackDate = !assessment.FeedbackDate || assessment.FeedbackDate == member.FlightDate;
                var needsFeedback = !member.IsExist && saAimsIdsNeedFeedback.includes(member.CrewAimsId);
                var hasCommonFlight = saAimsIdsWithCommonFlights.includes(member.CrewAimsId);

                return matchesFeedbackDate && needsFeedback && hasCommonFlight;
            });
        }

        function updateShowSaAssessmentModal(canShowModal){
            var feedbacksInfo = getFeedbacksInfo();
            if (feedbacksInfo) {
                feedbacksInfo.showSaAssessmentModal = canShowModal;
                GenericService.saveOne(feedbacksInfo, objType, objCallback);
            }
        }

        return service;
    }

})();
